import { useAppData } from '../contexts/AppDataContext';

/**
 * The farm picked in the sidebar switcher. Pages read it instead of drawing their own farm dropdown.
 * farmId is null in "All farms" mode; the API then returns every farm the user can access.
 * Put farmId in query keys so switching farms refetches.
 */
export default function useCurrentFarm() {
  const { farms, selectedFarmId, selectedFarm, setSelectedFarmId, loadingFarms } = useAppData();

  return {
    farmId: selectedFarmId,
    farm: selectedFarm,
    farms: farms || [],
    isAllFarms: selectedFarmId == null,
    setFarmId: setSelectedFarmId,
    loading: loadingFarms,
  };
}

/**
 * For screens that work on one farm at a time (finance, tagging, milk, drafting, …).
 * The sidebar farm wins and the screen hides its own farm picker; in "All farms" mode
 * the screen keeps its own pick (localFarmId) and shows its picker.
 */
export function useSingleFarmScope(localFarmId, setLocalFarmId) {
  const { farmId, setFarmId, isAllFarms } = useCurrentFarm();

  return {
    farmId: farmId ?? localFarmId,
    setFarmId: isAllFarms ? setLocalFarmId : setFarmId,
    showFarmPicker: isAllFarms,
  };
}
